module.exports = __webpack_public_path__ + "static/img/zhanhuo-logo.e8a1a5e0.png";